RivalIQ.apps.Dashboard.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.Wizard = RivalIQ.views.LayoutView.extend({
        template: '#wizardViewTemplate',
        regions: {
            main: '.x-wizard-pane'
        },

        onBeforeShow: function () {
            const me = this;
            const view = me.getOption('view');
            me.main.show(view);
        }
    });
});
